
import { defineComponent } from "vue";
import { useDataSource, useGammaData } from "@/services";
import { mapState } from "pinia";
import { ColumnDefinition } from "@gamma/types.data";
import { titleCase } from "@/util/helpers";

export default defineComponent({
  name: "DisplayColumnSelector",
  data: () => ({
    selection: [] as any[],
  }),
  computed: {
    ...mapState(useGammaData, [
      "activeSourceId",
      "tableDefinition",
      "request",
      "columnDefinitions",
    ]),
    reqCols: {
      get(): any[] {
        return this.tableDefinition?.request.displayColumns || [];
      },
      set(val: any[]) {
        if (this.activeSourceId) {
          const ds = useDataSource(this.activeSourceId)();
          ds.update("source", {
            ...ds.source,
            dataRequest: {
              ...ds.source.dataRequest,
              displayColumns: val,
            },
          });
        }
      },
    },
    columns(): ColumnDefinition[] {
      const sourceStore = useDataSource(this.activeSourceId)();
      return sourceStore.bottomColumnDefinitions || [];
    },
    uniqueIdColumnsSet(): Set<string> {
      if (this.activeSourceId) {
        return new Set<string>(
          useDataSource(this.activeSourceId)().uniqueIdColumns.map(
            (x) => x.columnName
          )
        );
      }
      return new Set<string>();
    },
  },
  watch: {
    tableDefinition: {
      handler(val) {
        if (val) {
          this.updateSelectOptions();
        }
      },
      immediate: true,
    },
  },
  methods: {
    updateSelectOptions() {
      this.selection = this.columns
        .filter((c) => c.visible)
        .map((c) => ({
          text: c.displayName || titleCase(c.columnName),
          value: c.columnName,
          visible: (this.reqCols.map((dc: any) => dc.name) || []).includes(
            c.columnName
          ),
        }));
    },
    toggleColumn(item: any) {
      if (this.uniqueIdColumnsSet.has(item.value)) {
        return;
      }
      const reqCols = this.reqCols;
      const index = reqCols.findIndex((c) => c.name === item.value);
      if (index > -1) {
        reqCols.splice(index, 1);
      } else {
        const col = this.columns.find((c) => c.columnName === item.value);
        if (col) {
          reqCols.push({
            label: col.columnName,
            name: col.columnName,
            orderInSelectList: reqCols.length + 1,
            visible: true,
          });
        }
      }
      this.reqCols = reqCols;
      this.updateSelectOptions();
      if (this.activeSourceId) {
        useDataSource(this.activeSourceId)().fetchData();
      }
    },
  },
});
